import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import OrganizationsContentDetails from '../OrganizationsContentDetails';
import OrganizationsContentMembers from '../OrganizationsContentMembers';


// todo: move logic of redirecting if organization not found to separate HOC function (DRY for the win)

const OrganizationsContent = ({ organizations }) => (
  <Switch>
    <Route
      exact
      from="/organizations/:organizationId"
      render={({ match }) => {
        const { params } = match;
        const { organizationId } = params;

        return (
          <Redirect to={`/organizations/${organizationId}/details`} />
        );
      }}
    />
    <Route
      exact
      path={'/organizations/:organizationId/members'}
      render={(props) => {
        const { match } = props;
        const { params } = match;
        const { organizationId } = params;
        const organizationKeys = organizations.map(organization => organization.id);

        if (organizationKeys.includes(organizationId) !== true) {
          return (
            <Redirect to="/organizations" />
          );
        }

        return (
          <OrganizationsContentMembers {...props} />
        );
      }}
    />
    <Route
      exact
      path={'/organizations/:organizationId/details'}
      render={(props) => {
        const { match } = props;
        const { params } = match;
        const { organizationId } = params;
        const organizationKeys = organizations.map(organization => organization.id);

        if (organizationKeys.includes(organizationId) !== true) {
          return (
            <Redirect to="/organizations" />
          );
        }

        return (
          <OrganizationsContentDetails {...props} />
        );
      }}
    />
  </Switch>
);

export default OrganizationsContent;



// WEBPACK FOOTER //
// ./src/components/OrganizationsContent/OrganizationsContent.jsx